import { render, staticRenderFns } from "./IpqcSetList.vue?vue&type=template&id=5d1aab6a"
import script from "./IpqcSetList.vue?vue&type=script&lang=js"
export * from "./IpqcSetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports